import {
  RENTS_RESET,
  RENT_SENDING,
  RENT_DOWNLOADED,
  RENTS_DOWNLOADED,
  RENTS_FAILED,
  RENTS_PENDING,
  RENTS_CLIENT_DOWNLOADED, RENTS_CSV_DOWNLOADED, RENTS_CSV_PENDING,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  contentClients: null,
  pending: false,
  sending: false,
  nb_rents: 0,
  csv_rents: null,
  csv_pending: false,
};

export default function (state = INITIAL_STATE, action) {
  let rents = [];
  let rentIndex = -1;
  switch (action.type) {
    case RENTS_RESET:
      return INITIAL_STATE;
    case RENTS_PENDING:
      return {
        ...state,
        error: null,
        pending: true,
      };
    case RENTS_CSV_PENDING:
      return {
        ...state,
        error: null,
        csv_pending: true,
      };
    case RENTS_DOWNLOADED:
      if (state.content) {
        const currentRents = state.content.slice();
        const rentsDownloaded = action.payload.rents;
        rentsDownloaded.forEach((rentDownloaded) => {
          rentIndex = currentRents.findIndex((rent) => rent.id === rentDownloaded.id);
          if (rentIndex === -1) {
            currentRents.push(rentDownloaded);
          } else {
            currentRents[rentIndex] = rentDownloaded;
          }
        });
        return {
          ...state,
          error: null,
          pending: false,
          sending: false,
          content: currentRents,
          nb_rents: action.payload.nb_rents,
        };
      }
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: action.payload.rents,
        nb_rents: action.payload.nb_rents,
      };

    case RENTS_CSV_DOWNLOADED:
      return {
        ...state,
        error: null,
        csv_pending: false,
        sending: false,
        csv_rents: action.payload,
      };
    case RENTS_CLIENT_DOWNLOADED:
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        contentClients: action.payload,
      };
    case RENT_SENDING:
      return {
        ...state,
        sending: true,
      };
    case RENT_DOWNLOADED:
      if (state.content) {
        rents = state.content.slice();
        rentIndex = rents.findIndex((rent) => rent.id === action.payload.id);
      }
      if (rentIndex !== -1) {
        rents[rentIndex] = action.payload;
      }
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: rents,
      };
    case RENTS_FAILED:
      return {
        ...state,
        error: action.payload,
        pending: false,
        sending: false,
      };
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/rents/reducers.js